export function readableRefDate(refDate) {
  if (typeof refDate !== 'string') {// handle non string arguments
    console.log('refDate in readableRefDate() not a string');
    return '';
  }
  if (refDate.length !== 6) {// handle non string arguments, must be 'YYYYq(1|2|3|4)''
    console.log('refDate in readableRefDate() not string of length 6');
    return '';
  }
  const refYear = parseInt(refDate.slice(0,4),10);
  const refQuarter = refDate.slice(4,6);
  const yearMapping = refQuarter === 'q4' ? [refYear, refYear] : [(refYear - 1), refYear];
  const monthDayMapping = {
    q1: ['04-01','03-31'],
    q2: ['07-01','06-30'],
    q3: ['10-01','09-30'],
    q4: ['01-01','12-31']
  };
  return `${yearMapping[0]}-${monthDayMapping[refQuarter][0]} through ${yearMapping[1]}-${monthDayMapping[refQuarter][1]}`;
}